// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1uMFi","col":"CardReaderDesc_col__2zrYj","label":"CardReaderDesc_label__2c0r6"};